import React from 'react';
import BreadcrumbsContainer from '../../containers/common/breadcurmbs/BreadcrumbsContainer';
import GroupsAccountsContainer from '../../containers/groups-accounts/GroupsAccountsContainer';
//-----------------------------------------------------------------------------------------
const GroupsAccountsPage = () => {
  return (
    <>
      <BreadcrumbsContainer title="결산 관리/조직별" icon="statistics" />
      <GroupsAccountsContainer />
    </>
  );
};

export default GroupsAccountsPage;
